<template>
    <div class="urao-faq-section">
        <div class="wrapper">
            <div class="urao-faq-section__title">{{ translateTitle }}</div>
            <div
                ref="stickyTrigger"
                @click="toggleStickyHeader"
                class="sticky-trigger"
            >
                <i class="fas fa-filter"></i>
            </div>
            <div class="urao-faq__header" ref="faqHeader">
                <div class="search-bar-container">
                    <input
                        type="text"
                        v-model="search"
                        ref="search-bar"
                        :placeholder="translateSearch"
                    />
                    <i class="fal fa-search"></i>
                </div>
                <div class="select-list-container">
                    <search-list
                        :class-name="'qualifications'"
                        :list-title="translateQualifications"
                        :list-items="qualificationItems"
                        :make-empty="makeQualificationEmpty"
                        @submit-list="updateSelectedQualification"
                    />
                    <search-list
                        :class-name="'stage'"
                        :list-title="translateStage"
                        :list-items="stageItems"
                        :make-empty="makeStageEmpty"
                        @submit-list="updateSelectedStage"
                    />
                </div>
                <div class="select-category-container">
                    <search-boxes
                        :class-name="'select-boxes__category'"
                        :boxes-items="categoryItems"
                        :make-empty="makeCategoryEmpty"
                        @submit-boxes="updateSelectedCategory"
                    />
                </div>
                <div class="accordion-trigger-all" @click="toggleTriggerAll">
                    <template v-if="!isAllActive">
                        <div class="text">{{ translateExpandAll }}</div>
                        <img
                            class="accordion-icon"
                            src="/themes/custom/usturao/img/icons/icon_expand.png"
                        />
                    </template>
                    <template v-else>
                        <div class="text">{{ translateCollapseAll }}</div>
                        <img
                            class="accordion-icon"
                            src="/themes/custom/usturao/img/icons/icon_collapse.png"
                        />
                    </template>
                </div>
            </div>
            <div class="urao-faq__body" ref="faqBody">
                <transition name="slide-down">
                    <div key="1" v-if="loading" class="question-list__loader">
                        {{ translateLoading }}
                    </div>
                    <div key="2" v-else class="urao-faq__question-list">
                        <question-list
                            :question-items="filtedQuestionItems"
                            :is-all-active="isAllActive"
                        />
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
const axios = require("axios");
import SearchList from "./components/SearchList.vue";
import SearchBoxes from "./components/SearchBoxes.vue";
import QuestionList from "./components/QuestionLists.vue";

export default {
    name: "faq",
    components: {
        "search-list": SearchList,
        "search-boxes": SearchBoxes,
        "question-list": QuestionList,
    },
    data() {
        return {
            questionItems: [],
            categoryItems: [],
            qualificationItems: [],
            stageItems: [],
            search: "",
            selectedCategory: "",
            selectedQualification: "",
            selectedStage: "",
            loading: true,
            isAllActive: false,
            makeSearchBarEmpty: false,
            makeCategoryEmpty: false,
            makeQualificationEmpty: false,
            makeStageEmpty: false,
            translateTitle: window.Drupal.t("FAQ"),
            translateSearch: window.Drupal.t("Search by keywords"),
            translateExpandAll: window.Drupal.t("Expand all questions"),
            translateCollapseAll: window.Drupal.t("Collapse all questions"),
            translateLoading: window.Drupal.t("Loading..."),
            translateQualifications: window.Drupal.t("Qualifications"),
            translateStage: window.Drupal.t("Application Stage"),
        };
    },
    computed: {
        filtedQuestionItems() {
            return this.questionItems.filter((questionItem) => {
                const categoryResult = questionItem.category.indexOf(
                    this.selectedCategory
                );
                const qualificationResult = questionItem.category.indexOf(
                    this.selectedQualification
                );
                const stageResult = questionItem.stage.indexOf(
                    this.selectedStage
                );
                const keywordSearchResult = questionItem.question
                    .toLowerCase()
                    .includes(this.search.toLowerCase());

                if (this.search !== "") {
                    return keywordSearchResult === true;
                } else if (this.selectedCategory !== "") {
                    return categoryResult !== -1;
                } else if (
                    this.selectedQualification !== "" ||
                    this.selectedStage !== ""
                ) {
                    return qualificationResult !== -1 && stageResult !== -1;
                } else {
                    return questionItem;
                }
            });
        },
    },
    watch: {
        search(newVal, oldVal) {
            if (newVal === oldVal || newVal === "") return;
            this.makeSearchBarEmpty = false;
            this.makeCategoryEmpty = true;
            this.makeQualificationEmpty = true;
            this.makeStageEmpty = true;
        },
        selectedCategory(newVal, oldVal) {
            if (newVal === oldVal || newVal === "") return;
            this.makeSearchBarEmpty = true;
            this.makeCategoryEmpty = false;
            this.makeQualificationEmpty = true;
            this.makeStageEmpty = true;
        },
        selectedQualification(newVal, oldVal) {
            if (newVal === oldVal || newVal === "") return;
            this.makeSearchBarEmpty = true;
            this.makeCategoryEmpty = true;
            this.makeQualificationEmpty = false;
            this.makeStageEmpty = false;
        },
        selectedStage(newVal, oldVal) {
            if (newVal === oldVal || newVal === "") return;
            this.makeSearchBarEmpty = true;
            this.makeCategoryEmpty = true;
            this.makeQualificationEmpty = false;
            this.makeStageEmpty = false;
        },
    },
    methods: {
        toggleStickyHeader() {
            const header = this.$refs.faqHeader;

            header.classList.contains("active")
                ? header.classList.remove("active")
                : header.classList.add("active");
        },
        stickyHeader() {
            window.onscroll = () => {
                const trigger = this.$refs.stickyTrigger;
                const header = this.$refs.faqHeader;
                const body = this.$refs.faqBody;
                const sticky = body.getBoundingClientRect().top;

                if (sticky < 0) {
                    header.classList.add("sticky");
                    trigger.classList.add("sticky");
                    body.style.marginTop = `${header.clientHeight}px`;
                } else {
                    header.classList.remove("sticky");
                    trigger.classList.remove("sticky");
                    body.style.marginTop = 0;
                }
            };
        },
        toggleTriggerAll() {
            this.isAllActive = !this.isAllActive;
        },
        updateSelectedCategory(category) {
            this.selectedCategory = category;
        },
        updateSelectedQualification(qualification) {
            this.selectedQualification = qualification;
        },
        updateSelectedStage(stage) {
            this.selectedStage = stage;
        },
        makeRequest() {
            const urlHref = new URL(location.href).href;
            const hant = urlHref.indexOf("/zh-hant/");
            const hans = urlHref.indexOf("/zh-hans/");
            const lang = hant != -1 ? "/zh-hant" : hans != -1 ? "/zh-hans" : "";
            let questions = `${lang}/api/faq-questions`;
            let categories = `${lang}/api/faq-category`;
            let qualifications = `${lang}/api/faq-qualifications`;
            let stages = `${lang}/api/faq-stage`;

            const requestQuestions = axios.get(questions);
            const requestCategories = axios.get(categories);
            const requestQualifications = axios.get(qualifications);
            const requestStages = axios.get(stages);

            axios
                .all([
                    requestQuestions,
                    requestCategories,
                    requestQualifications,
                    requestStages,
                ])
                .then(
                    axios.spread((...responses) => {
                        const requestQuestions = responses[0];
                        const requestCategories = responses[1];
                        const requestQualifications = responses[2];
                        const requestStages = responses[3];
                        // use/access the results
                        this.questionItems = requestQuestions.data;
                        this.categoryItems = requestCategories.data;
                        this.qualificationItems = requestQualifications.data;
                        this.stageItems = requestStages.data;
                    })
                )
                .catch((errors) => {
                    // react on errors.
                    console.log(errors);
                })
                .finally(() => (this.loading = false));
        },
    },
    mounted() {
        this.makeRequest();
        this.stickyHeader();
    },
};
</script>

<style lang="less">
@body: "Muli", "Microsoft JhengHei", "微軟正黑體", sans-serif;
@mobile: ~"only screen and (max-width: 767px)";
@tablet: ~"only screen and (min-width: 768px) and (max-width: 999px)";
@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.translateFont() {
    &:lang(zh-hant),
    &:lang(zh-hans) {
        font-size: 18px;
    }
}

.urao-faq-section {
    max-width: 1000px;
    margin: 50px auto;
    padding-bottom: 50px;

    .sticky-trigger {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 5px;
        left: 0;
        width: 40px;
        height: 40px;
        background: #ffcc32;
        color: #1e3b70;
        opacity: 0;
        visibility: hidden;
        z-index: 11;

        @media @mobile {
            &.sticky {
                opacity: 1;
                visibility: visible;
                transition: 0.3s all ease;
            }
        }
    }
    &__title {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-bottom: 35px;
        font-size: 35px;
        line-height: 1em;
        font-weight: 800;
        text-transform: uppercase;
        @media @tablet {
            font-size: 25px;
            line-height: 1.2em;
        }
        @media @mobile {
            justify-content: flex-start;
            margin-bottom: 25px;
            font-size: 30px;
        }
        &:before {
            content: "\f111";
            font-family: "Font Awesome 5 Pro";
            font-weight: 900;
            color: #ffcc32;
            font-size: 15px;
            margin-right: 10px;
            @media @tablet {
                font-size: 12px;
            }
        }
    }
    @media @mobile {
        margin: 25px auto;
    }
    .urao-faq {
        &__header {
            margin: 10px 0;
            padding-top: 15px;

            .search-bar-container {
                position: relative;
                width: 100%;
                max-width: 300px;
                margin: 0 auto 15px;

                input {
                    width: 100%;
                    padding: 10px 30px 10px 10px;
                    box-sizing: border-box;
                }
                .fa-search {
                    position: absolute;
                    top: 12px;
                    bottom: 12px;
                    right: 10px;
                }
                @media @mobile {
                    max-width: 100%;
                }
            }
            .select-list-container {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
            }
            .select-category-container {
                .select-boxes__category--boxes {
                    &__items {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-wrap: wrap;
                    }
                    &__item {
                        cursor: pointer;
                        border: 2px solid #ffcc32;
                        padding: 0.4em;
                        margin: 0 7.5px 15px;
                        min-width: 155px;
                        font-size: 20px;
                        line-height: 1;
                        color: #6d6e71;
                        text-align: center;
                        white-space: nowrap;
                        transition: 0.3s all ease;

                        @media @tablet, @mobile {
                            font-size: 16px;
                        }
                        @media @mobile {
                            min-width: 0;
                            width: 100%;
                            max-width: 200px;
                        }
                        &.checked {
                            background: #ffcc32;
                            color: white;
                        }
                    }
                }
            }
            .accordion-trigger-all {
                flex: 0 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                white-space: nowrap;
                cursor: pointer;

                .accordion-icon {
                    width: 20px;
                    margin-left: 5px;
                }
            }
            &.sticky {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                z-index: 10;
                margin: 0;
                padding: 15px 20px 0;
                background: white;
                box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
                transition: 0.2s all ease;
                animation: fadeIn 0.3s forwards linear;

                > div {
                    max-width: 970px;
                    margin: 0 auto;

                    &.search-bar-container {
                        margin: 0 auto 15px;
                    }
                }
                .accordion-trigger-all {
                    margin-bottom: 15px;
                }

                @media @mobile {
                    padding: 15px 30px 0;
                    opacity: 0;
                    visibility: hidden;
                    transform: translateX(-100%);

                    &.active {
                        opacity: 1;
                        visibility: visible;
                        transform: translateX(0);
                        transition: 0.3s all ease;
                    }
                }
            }
        }
        &__body {
            // max-width: 600px;
            margin: 0 auto;
        }
    }
    .slide-down-enter-active {
        transition: transform 0.6s ease, opacity 0.6s ease;
    }
    .slide-down-enter,
    .slide-down-leave-to {
        opacity: 0;
        transform: translateY(-2em);
    }
    .slide-in-enter-active {
        transition: all 0.6s ease;
        transition-delay: calc(0.1s * var(--i));
    }
    .slide-in-enter,
    .slide-in-leave-to {
        opacity: 0;
        height: 0;
        overflow: hidden;
        transform: translateX(-2em);
    }
}
</style>
